import { merge } from 'lodash';
import { CacheTags } from '../constants/CacheTags';

/**
 * Fetches a URL with the given options and adds the Authorization header with the given token. Also sets the 'auth' cache tag for manual cache revalidation and a default cache TTL of 5 minutes.
 * @param url The URL to fetch.
 * @param token The token to use for the Authorization header.
 * @param init The options to pass to the fetch call.
 * @returns The response from the fetch call.
 */
const authFetch = async (url: URL | RequestInfo, token?: string, init?: RequestInit): Promise<Response> => {
	const defaultInit: RequestInit = {
		headers: { Authorization: `Bearer ${token}` },
		credentials: 'include',
		next: {
			revalidate: 300,
			tags: [CacheTags.Auth],
		},
	};

	if (init?.method && init?.method !== 'GET') {
		delete defaultInit.next;
		defaultInit.cache = 'no-store';
	}

	return fetch(url, merge(init, defaultInit));
};

export default authFetch;
